import { observer } from 'mobx-react-lite';
import { FC } from 'react';

import { Sticker } from 'APP/components/Sticker/Sticker';
import { STICKER_BUBBLE_MAX_HEIGHT, STICKER_BUBBLE_MAX_WIDTH } from 'APP/constants/stickers';
import { ChatMessage } from 'STORE/Messages/Message/ChatMessage/ChatMessage';

import { useStickerPayloadPresenter } from './StickerPayload.presenter';

interface IStickerPayloadProps {
  message: ChatMessage;
}

export const StickerPayload: FC<IStickerPayloadProps> = observer(({ message }) => {
  const presenter = useStickerPayloadPresenter();

  return (
    <Sticker
      sticker={message.payload}
      displayUILayer={0}
      maxWidth={STICKER_BUBBLE_MAX_WIDTH}
      maxHeight={STICKER_BUBBLE_MAX_HEIGHT}
      stickerPackId={message.payload.stickerPackId}
      onClick={presenter.onOpenStickerPack}
    />
  );
});
